import { apiClient } from "@/services/apiClient";

export interface PartnerDiscountStage {
  discountType: "flat" | "percent";
  discountValue: number;
  durationMonths: number;
}

export interface PartnerLookupResult {
  valid: boolean;
  name?: string;
  stages?: PartnerDiscountStage[];
}

/** Public, unauthenticated — used by the register page to show a benefit banner before submit. */
export function lookupPartnerCode(code: string): Promise<PartnerLookupResult> {
  return apiClient
    .get<PartnerLookupResult>(`/partners/code/${encodeURIComponent(code)}`)
    .then((res) => res.data);
}
